import { useState, useEffect } from "react"
import { Item1 } from "./carousel/Item1"
import { Item2 } from "./carousel/Item2"
import { Item3 } from "./carousel/Item3"
import "./carousel.css"

export function Carousel() {
    const [activeIndex, setActiveIndex] = useState(0)
    const dots = [0, 1, 2]
    var x;
    
    useEffect(() => {
        x = setTimeout(() => {
            if (activeIndex === dots.length - 1) {
                setActiveIndex(0)
            } else {
                setActiveIndex(activeIndex + 1)
            }
        }, 2000)
    }, [activeIndex])

    function slideTo(i) {
        clearTimeout(x)
        setActiveIndex(i)
    }

    return (
        <div className="slider lg-on border overflow-hidden position-relative mx-auto">
            <div className="slider-container position-relative d-flex" style={{
                left: (-100 * activeIndex) + "%",
                transition: "0.3s"
            }}>
                <Item1 />
                <Item2 />
                <Item3 />
            </div>

            <div className="indicators-section d-flex justify-content-center w-100 position-absolute">
                {
                    dots.map(e => (
                        <div
                            key={e}
                            onClick={() => slideTo(e)}
                            className={"slider-indicator " + (activeIndex === e && "active")}>
                        </div>
                    ))
                }
            </div>
        </div>
    )
}